/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Question Component Types.
 */
export enum ComponentType {
  SELECT = 'select',
  MULTI_SELECT = 'multi_select',
  TEXT = 'text',
  TEXTAREA = 'textarea',
  NUMBER = 'number',
  CHECK_BOX = 'check_box',
  RADIO = 'radio',
  DATE = 'date',
  DATETIME = 'datetime',
  ADDRESS = 'address',
  SLOT = 'slot',
  DECIMAL_PERCENTAGE = 'decimal_percentage',
  PERCENTAGE = 'percentage',
  SINGLE_CHECKBOX = 'single_checkbox',
  CUSTOM = 'custom',
  CHECK_BOX_ADD = 'check_box_add',
  CHECKBOX_REMOVE = 'checkbox_remove',
  CURRENCY = 'currency',
  FILE_UPLOAD = 'file_upload',
  TOGGLE = 'toggle',
  DOCUMENT_SIGNATURE = 'document_signature',
  PHONE_NUMBER = 'phone_number',
  EMAIL = 'email',
  STATIC_INFO = 'static_info',
  SQUARE_FEET = 'square_feet',
  R_VALUE = 'r_value',
  CATALOG_EQUIPMENT = 'catalog_equipment',
  SIMPLE_EQUIPMENT = 'simple_equipment',
  TASK_SELECTION = 'task_selection',
  SEARCH_INPUT = 'search_input',
  HEAT_PUMP_CATALOG = 'heat_pump_catalog',
  HEAT_PUMP_CATALOG_DUAL_FUEL = 'heat_pump_catalog_dual_fuel',
  HEAT_PUMP_LEGACY = 'heat_pump_legacy',
  WATER_HEATER_CATALOG = 'water_heater_catalog',
  UTILITY_SEARCH = 'utility_search',
  FILTERED_SELECT = 'filtered_select',
  TERMS_AND_CONDITIONS = 'terms_and_conditions',
  TABS = 'tabs',
  INTEGRATED_CONTROLS_SELECTOR = 'integrated_controls_selector',
  JOB_SERVICE_EQUIPMENT = 'job_service_equipment',
  PERCENTAGE_SPLIT = 'percentage_split',
  EVAPORATIVE_COOLER_CATALOG = 'evaporative_cooler_catalog',
  ADDITIONAL_INCENTIVES = 'additional_incentives',
  VENT_FAN_CATALOG = 'vent_fan_catalog',
}
